module.exports = __webpack_public_path__ + "static/media/milk.9dca0fbc.jpg";